/*
 * ListItemIcon.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./ListItemIcon.scss";

export interface IListItemIconProps {
	children?: React.ReactNode;
	className?: string;
}

export const ListItemIcon: React.FC<IListItemIconProps> = ({ children, className }) => {
	const baseClass = BEM("edt-list-item-icon");

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
